import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Footer } from "../../layouts/footer";
import { Eye, PencilLine, Trash } from "lucide-react";
import config from "../../../config";

const ManageProduct = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch(`${config.baseURL}/products`)
      .then((response) => response.json())
      .then((data) => setProducts(data))
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;

    fetch(`${config.baseURL}/delete/${id}`, {
      method: "DELETE",
    })
      .then((response) => {
        if (response.ok) {
          setProducts((prevProducts) =>
            prevProducts.filter((product) => product.id !== id)
          );
          alert("Product deleted successfully");
        } else {
          alert("Error deleting product");
        }
      })
      .catch((error) => {
        console.error("Error deleting product:", error);
        alert("Error deleting product");
      });
  };

  return (
    <div className="flex flex-col gap-y-6 px-4">
      <h1 className="text-2xl font-semibold text-gray-800 dark:text-white">📦 Product Management</h1>

      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow">
        <div className="flex justify-between items-center px-4 py-3 border-b dark:border-gray-700">
          <h2 className="text-lg dark:text-white font-semibold">Manage Products</h2>
          <NavLink
            to="/admin/addproduct"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-md transition"
          >
            + Add Product
          </NavLink>
        </div>

        <div className="overflow-x-auto max-h-[500px] rounded-b-lg">
          <table className="min-w-full text-sm text-left text-gray-700 dark:text-gray-300">
            <thead className="bg-gray-100 dark:bg-gray-800 sticky top-0">
              <tr>
                <th className="px-4 py-3">#</th>
                <th className="px-4 py-3">Product Name</th>
                <th className="px-4 py-3">Price (2–249)</th>
                <th className="px-4 py-3">Price (250–999)</th>
                <th className="px-4 py-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr
                  key={product.id}
                  className="hover:bg-gray-50 dark:hover:bg-gray-800 border-b dark:border-gray-700"
                >
                  <td className="px-4 py-3 font-medium">{index + 1}.</td>
                  <td className="px-4 py-3">{product.name}</td>
                  <td className="px-4 py-3">
                    {product.price_1_249 ? (
                      `₹${product.price_1_249}`
                    ) : (
                      <span className="bg-gray-200 dark:bg-gray-700 text-xs px-2 py-1 rounded-full">N/A</span>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    {product.price_250_999 ? (
                      `₹${product.price_250_999}`
                    ) : (
                      <span className="bg-gray-200 dark:bg-gray-700 text-xs px-2 py-1 rounded-full">N/A</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <div className="flex justify-center items-center gap-x-3">
                      <NavLink
                        to={`/admin/viewproduct/${product.id}`}
                        className="bg-green-100 text-green-700 p-2 rounded-full hover:bg-green-200 dark:hover:bg-green-900 transition"
                        title="View"
                      >
                        <Eye size={18} />
                      </NavLink>
                      <NavLink
                        to={`/admin/editproduct/${product.id}`}
                        className="bg-yellow-100 text-yellow-700 p-2 rounded-full hover:bg-yellow-200 dark:hover:bg-yellow-900 transition"
                        title="Edit"
                      >
                        <PencilLine size={18} />
                      </NavLink>
                      <button
                        onClick={() => handleDelete(product.id)}
                        className="bg-red-100 text-red-700 p-2 rounded-full hover:bg-red-200 dark:hover:bg-red-900 transition"
                        title="Delete"
                      >
                        <Trash size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {products.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center px-4 py-6 text-gray-500 dark:text-gray-400">
                    No products found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ManageProduct;
